export const FOOTER_SELECT_COUNTRY_TEST_ID = "footer-select-country";
